import React from 'react';
import './styles/main.css'; // Make sure this line is present
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import ProblemStatement from './components/ProblemStatement/ProblemStatement';
import SolutionOverview from './components/SolutionOverview/SolutionOverview';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Features from './components/Features/Features';
import FAQs from './components/FAQs/FAQs';
import Footer from './components/Footer/Footer';
import Founder from './components/About/Founder'; // Import the new component
import GetInTouch from './components/GetInTouch/GetInTouch'; // Import the new component

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Hero />
        <section id="solution">
          <SolutionOverview />
        </section>
        <section id="features">
          <Features />
        </section>
        <section id="founder">
          <Founder />
        </section>
        <section id="get-in-touch">
          <GetInTouch />
        </section>
        <section id="faqs">
          <FAQs />
        </section>
      </main>
      {/* <Footer /> */}
    </div>
  );
}

export default App;